import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { handleModal } from '../../redux/actions/modals';
//PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
import { WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
//PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - End
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
import { calculateCVF, getAppInfoData, getDyanmicURL, getProductTypeValue } from '../../utils/global_functions';
import { APP_INFO_PARAMS } from '../../utils/global_variables';
import { Col, Container, Row } from 'react-bootstrap';
import { getOrderMarginInfo } from '../../redux/actions/orders';
//PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End


const BrokerageCharges = ({ brokerageParams, activeButtonToggleIndex, ...props }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const appInfo = useSelector(state => state?.appInfo?.appInfo);
    // console.log('app info',appInfo)
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const objScripOrderInfo = useSelector(state => state.orders.scripOrderInfo);
    const arrMarginInfo = useSelector(state => state.orders.arrMarginInfo);

    const { scripOrderInfo } = useMemo(() => ({ scripOrderInfo: objScripOrderInfo?.scripData }), [objScripOrderInfo]);
    //  console.log('scrip order info',scripOrderInfo)
    const [brokerageUrl, setBrokerageUrl] = useState('');

    useEffect(()=>{
        const arrLegDetails = [
            {
                "LegNo": 1,
                "BuyOrSell": brokerageParams?.transactiontype,
                "MarketSegmentId": scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                "Token": scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN],
                "Quantity": brokerageParams?.quantity,
                "Price": Math.round(brokerageParams?.price * scripOrderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]),
                "MktFlag": brokerageParams?.mktType?.includes('MKT') ? 1 : 0,
                "OldPrice": 0,
                "OldQuantity": 0,
                "ProductType": getProductTypeValue(brokerageParams?.producttype),
                "LegIndicator": 0
            }
        ];
        dispatch(getOrderMarginInfo(arrLegDetails));
    },[brokerageParams?.producttype])

    //PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start
    const showBrokerage = useCallback((objBrokerageData) => {
        try {
            //Vaibhav Singh : BT-106776 - 08-11-2023-  MarginData removed from here - Start
            if (objBrokerageData?.url && scripOrderInfo?.length && Object.keys(brokerageParams)?.length) {
                //Vaibhav Singh : BT-106776 - 08-11-2023-  MarginData removed from here - End
                // Vinit Raut 25-04-2024 : BT-106776_Breeze-Breeze - Display Brokerage and statutory charge -- Start
                const priceLocatorObj = {
                    price_num: scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_NUMERATOR],
                    price_den: scripOrderInfo[WATCHLIST_GRID_INDEX.PRICE_DENOMINATOR],
                    gen_num: scripOrderInfo[WATCHLIST_GRID_INDEX.AVM_BUY_MARGIN],
                    gen_den: scripOrderInfo[WATCHLIST_GRID_INDEX.AVM_SELL_MARGIN],
                    market_lot: scripOrderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT],
                    preferred_mktSegId: String(scripOrderInfo[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID])
                };

                const params = {
                    ...brokerageParams,
                    url: objBrokerageData?.url,
                    type: objBrokerageData.encryptiontype || 1,
                    mktsegid: scripOrderInfo[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                    series: scripOrderInfo[WATCHLIST_GRID_INDEX.SERIES],
                    //Vaibhav Singh: 07-12-23: Display Brokerage Charges: arrMargin filed changes: start
                    brokerage: parseFloat(arrMarginInfo?.Brokerage) || 0.00,
                    //Vaibhav Singh: 07-12-23: Display Brokerage Charges: arrMargin filed changes: End
                    legIndicator: 1,
                    theme: "L",
                    instrument: scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT],
                    priceLocator: calculateCVF(priceLocatorObj)
                };
                // Vinit Raut 25-04-2024 : BT-106776_Breeze-Breeze - Display Brokerage and statutory charge -- End
                //BT-107437: Functional Implementation InvestMents : Vaibhav Singh : 21-08-2023 : Implemented Value for Dyanamic URl
                setBrokerageUrl(getDyanmicURL(params, objLoginSession));
            }
        } catch (error) {
            // console.log(error);
        }
    }, [scripOrderInfo, arrMarginInfo, objLoginSession, brokerageParams]);

    //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - Start
    useEffect(() => {
        //  console.log('Before calling getAppInfoData')
        const objBrokerageData = getAppInfoData(APP_INFO_PARAMS.APP_BROKERAGE_MODE, appInfo);
        //  console.log('brokerage details',objBrokerageData)
        showBrokerage(objBrokerageData);
    }, [appInfo, showBrokerage]);
    //PrachiTawde : 05-05-2023 : BT-107252 -  Breeze – Rate us & Feedback - End


    const onHide = () => {
        dispatch(handleModal([{ "BROKERAGE_CHARGES_MODAL": false }]));
    };

    return (
        <Container fluid className='p-0'>
            <BzModal show={modals['BROKERAGE_CHARGES_MODAL']} onHide={onHide} centered>
                <BzModalHeader className='modaltabs-header modal-header' >
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={10} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>Brokerage and Charges</div>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-self-center'>
                                <div className='icon-16 icon-dark icon-close' onClick={onHide}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <iframe src={brokerageUrl} height='600px' width='100%' title='Brokerage Charges' />
                </BzModalBody>
            </BzModal>
        </Container>
    );
};

export default memo(BrokerageCharges);